module.exports = __webpack_public_path__ + "img/11.f5fc4dda.png";